import { type QueryHookOptions, useQuery } from "@apollo/client";
import { WidgetsListQuery } from "../graphql/queries";
import type { WidgetsListQueryType } from "@/types/graphql/partner.generated";

export const useWidgetsQuery = (
  options?: QueryHookOptions<WidgetsListQueryType>
) => {
  return useQuery<WidgetsListQueryType>(WidgetsListQuery, options);
};
